import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service'; // Ajusta la ruta

// La guarda ahora es síncrona, ¡mucho más limpia!
export const authGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    // Cuando esta guarda se ejecuta, podemos confiar en que el estado ya es el correcto.
    if (authService.isLoggedIn()) {
        return true; // Si está logueado, permite el acceso.
    } else {
        // Si no, redirige.
        return router.parseUrl('/authentication');
    }
};
